import { createSelector, createFeatureSelector } from '@ngrx/store';
import {
	fieldTeamDetailAdapter,
	FieldTeamDetailsState,
	fieldTeamDetailFeatureKey,
} from './field-team-detail.reducer';
import { getAllRailroadEntities } from 'src/admin-app/railroads/railroad-detail/+state/railroad-detail.selectors';
import { FieldTeam } from 'src/shared/api';

export const getFieldTeamDetailState = createFeatureSelector<
	FieldTeamDetailsState
>(fieldTeamDetailFeatureKey);

const { selectEntities } = fieldTeamDetailAdapter.getSelectors();

export const getLoadingStatus = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) => state.isLoading
);

export const getTitle = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) =>
		state.selectedFieldTeamId > 0 ? 'Edit FieldTeam' : 'Create Field Team'
);

export const getSelectedFieldTeamId = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) => state.selectedFieldTeamId
);

export const getAllFieldTeamEntities = createSelector(
	getFieldTeamDetailState,
	selectEntities
);

export const getSelectedFieldTeam = createSelector(
	getAllFieldTeamEntities,
	getSelectedFieldTeamId,
	(fieldTeamEntities, fieldTeamId) => fieldTeamEntities[fieldTeamId]
);

export const getFieldTeamEntity = (id: number) =>
	createSelector(getAllFieldTeamEntities, (entities) => entities[id]);

export const getCloseAfterSaving = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) => !state.shouldStayOnPage
);

export const getIsSaving = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) => state.isSaving
);

export const getError = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) => state.error
);

export const getShouldSaveButtonShake = createSelector(
	getFieldTeamDetailState,
	(state: FieldTeamDetailsState) => state.error && !state.shouldStayOnPage
);

const getRailroadIdForFieldTeam = createSelector(
	getSelectedFieldTeam,
	getFieldTeamDetailState,
	(_team: FieldTeam, _state: FieldTeamDetailsState) => {
		return null;
	}
);

export const getRailroadForFieldTeam = createSelector(
	getAllRailroadEntities,
	getRailroadIdForFieldTeam,
	(railroadEntities, railroadId) =>
		railroadEntities[railroadId] ? railroadEntities[railroadId] : null
);

export const getDivisionOptions = createSelector(
	getRailroadForFieldTeam,
	(railroad) => (railroad ? railroad.divisions : [])
);
